function layoutService($window, toastWrapperService, moment) {
  const service = {
    browserType: null,
    isMobileBrowser: null
  };

  service.getElementTopPositionById = (id) => {
    if (!$window.document.getElementById(id)) {
      return 0;
    }

    const { document, pageYOffset } = $window;
    const offset = pageYOffset || document.documentElement.scrollTop;

    return offset + document.getElementById(id).getBoundingClientRect().top;
  };

  service.triggerWindowResize = () => {
    let ev;
    if (service.browser() === 'ie' || service.browser() === 'phantom') {
      ev = document.createEvent('Event');
      ev.initEvent('resize', true, true);
    } else {
      ev = new Event('resize');
    }

    window.dispatchEvent(ev);
  };

  service.browser = () => {
    if (service.browserType === null) {
      service.browserType = service.checkBrowser();
    }
    return service.browserType;
  };

  service.checkBrowser = () => {
    const userAgent = $window.navigator.userAgent;

    const browsers = {
      phantom: /phantom/i,
      chrome: /chrome/i,
      safari: /safari/i,
      firefox: /firefox/i,
      ie: /internet explorer|11/i
    };

    let browser = 'unknown';

    Object.keys(browsers)
      .forEach((browserType) => {
        if (browsers[browserType].test(userAgent)) {
          browser = browserType;
        }
      });

    return browser;
  };

  service.isMobile = () => {
    if (service.isMobileBrowser === null) {
      service.isMobileBrowser = service.checkIsMobile();
    }

    return service.isMobileBrowser;
  };

  service.mobileBrowserType = {
    Android() {
      return /Android/i.test(navigator.userAgent);
    },
    BlackBerry() {
      return /BlackBerry/i.test(navigator.userAgent);
    },
    iOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    Windows() {
      return /IEMobile/i.test(navigator.userAgent);
    },
    any() {
      return (this.Android() || this.iOS() || this.BlackBerry() || this.Windows());
    }
  };

  service.checkIsMobile = () => (
    service.mobileBrowserType.Android()
    || service.mobileBrowserType.iOS()
    || service.mobileBrowserType.BlackBerry()
    || service.mobileBrowserType.Windows());

  service.mobileToast = (noticeType, noticeContent) => {
    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 992) {
      toastWrapperService.createToast(noticeContent, noticeType || 'danger');
    }
  };

  service.isPastDate = (date) => {
    if (!date) {
      return false;
    }

    return moment().diff(date * 1000) > 0;
  };

  return service;
}

const arr = [
  '$window',
  'toastWrapperService',
  'moment',
  layoutService
];

module.exports = (ngModule) => {
  ngModule.factory('layoutService', arr);
};
